const modelFactoryService = function ($http, apiConstants, $q) {
    /*
     This service is a helper for generation model according to the
     data given by http request to required url.
     Generic structure of the request to API is lokink like this:
     {
     firstProperty: firstValue,
     secondProperty: secondValue,
     links: [
     {rel: 'firstRel', href: 'firstHref'},
     {rel: 'secondRel', href: 'secondHref'}
     ]
     }
     ModelFactory service go through this structure and generetes Model
     object with all data which present in this structure as well as
     methods to give linked data according to links array if it presents
     */
    const ModelFactory = {
        // function attaches method to the model for
        // child data access
        // PARAMS:
        // model            - model where is required to attach methods
        // method           - this method comes from links array of data
        //                  which represents model. There is not required
        //                  to attach all methods which listed in links
        //                  array. Methods will be filtered by acceptableMethods
        //                  parameter
        //acceptableMethods - required methods
        createModelMethods: function (model, method, acceptableMethods) {
            acceptableMethods.filter(function (el) {
                return method.rel === el.rel || _.indexOf(el.rels, method.rel) !== -1
            }).forEach(function (currentMethod) {
                model[currentMethod.methodName] = function (data) {
                    const rxp = /%7B(.+?)%7D+/g;
                    let href = method.href;
                    const matches = getMatches(href, rxp, 1);
                    const requestTransformation = model[currentMethod.methodName].requestTransformation;
                    if (matches.length > 0) {
                        if (_.size(arguments) === matches.length) {
                            let idx = 0;
                            const args = arguments;
                            href = href.replace(rxp, function () {
                                return args[idx++];
                            })
                        } else throw new Error("Wrong arguments in link template")
                    }
                    return ModelFactory.getModel(href, currentMethod, data, {requestTransformation});
                };
            });
            return model;
        },
        // creates model according to the given data
        // and required methods. Current function
        // goes through link array of given data
        // and attaches method to the model according
        // to the element data
        // PARAMS:
        // data         - model data
        // apiMethods   - array of required methods according
        //              to current model
        createModel: function (data, apiMethods) {

            if (_.isArray(data) || _.isObject(data)) {
                _.forEach(data, function (value, key) {
                    data[key] = ModelFactory.createModel(value, apiMethods);
                });

                data.links && _.forEach(data.links, function (method) {
                    ModelFactory.createModelMethods(data, method, apiMethods);
                });

                data['linkTemplates'] && _.forEach(data['linkTemplates'], function (method) {
                    ModelFactory.createModelMethods(data, method, apiMethods, true);
                });
            }

            return data;
        },
        // generates model according to http response
        // given by http request to required url
        // PARAMS:
        // url      - address of the resource
        // type     - type of the http request
        // data     - data, wich will be passed to http
        //          request
        getModel: function (url, methodData, data, options) {
            const deferred = $q.defer();

            if (options?.requestTransformation) {
                let transformationResult = options.requestTransformation({url, methodData, data});
                url = transformationResult.url;
                methodData = transformationResult.methodData;
                data = transformationResult.data;
            }

            let type, dataRootPath, selfMethods;
            if (_.isString(methodData)) type = methodData;
            else {
                type = methodData.methodType;
                dataRootPath = methodData.dataRootPath;
                selfMethods = methodData.self;
            }

            $http(_.defaults({
                method: type,
                url: url,
                data: type != 'GET' ? data : '',
                rel: methodData.rel
            }, methodData.config))

                .then(function (res) {
                    let resData = res.data;
                    if (methodData.skipLinkTemplate) {
                        _.filter(resData.linkTemplates, {'rel': methodData.skipLinkTemplate}).map(function (el) {
                            el.rel = el.rel + ':skipped';
                        });
                    }
                    if (dataRootPath) resData = _.get(resData, dataRootPath, null);
                    const model = ModelFactory.createModel(resData, apiConstants.METHODS);
                     
                    // extend model by additional data
                    if (methodData.additionalData && methodData.additionalData instanceof Array) {
                        methodData.additionalData.forEach(function (el) {
                            model[el] = res.data[el];
                        });
                    }

                    _.forEach(selfMethods, function (selfMethod) {
                        model[selfMethod.methodName] = function (data) {
                            return ModelFactory.getModel(url, selfMethod, data);
                        };
                    });

                    deferred.resolve(model);
                }.bind(this), function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }
    };

    function getMatches(string, regex, index) {
        index || (index = 1); // default to the first capturing group
        const matches = [];
        let match;
        while (match = regex.exec(string)) {
            matches.push(match[index]);
        }
        return matches;
    }

    return ModelFactory;
};
modelFactoryService.$inject = ['$http', 'ApiConstants', '$q']

module.exports = modelFactoryService;
